/** @format */

import React, { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router";
import Loader from "../../Components/Loader";
import masterServices from "../../Services/masterService";
import { useLocation } from 'react-router-dom'
import CheckAccess from "../../Function/CheckAccess";

export const PackageMaster = () => {
  const [loader, setLoader] = useState(false);
  const history = useHistory();
  const [listData, setListData] = useState();
  // eslint-disable-next-line
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  // eslint-disable-next-line
  const [currentPage, setCurrentPage] = useState(1);
  const imgRef = useRef();

  const location = useLocation()
  let user_type = localStorage.getItem("user_type")

  useEffect(() => {
    getItemList();
    // eslint-disable-next-line
  }, [currentPage]);

  const getItemList = () => {
    let param = { ...pagination, page: currentPage };
    if (pagination.search) {
      param["page"] = 1;
    }
    masterServices.get_package(param).then((res) => {
      if (res.status) {
        setLoader(false);
        setListData(res);
        // setPagination(res.pagination)
      } else {
        setLoader(false);
      }
    });
  };

  const showLabel = (item) => {
    if (item.packing_type === "carton packing") {
      return item.rate_per_cmb + " /cbm";
    } else {
        return item.rate_per_cmb + " /sq mt";

    }
  };
  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-end mb-3">
            {
               (CheckAccess(213, 'edit') || user_type === "SUPERADMIN") && 
              <button
                className="btn btn-primary w-sm waves-effect waves-light mx-3"
                onClick={() =>
                  history.push(
                    "/edit-package-master?id=" + listData.data._id,
                    listData
                  )
                }
              >
                Edit package
              </button>
            }

              {/* <button className="btn btn-primary w-sm waves-effect waves-light mx-3"
                                onClick={() => history.push('/add-package-master')}
                            >Add Packing
                            </button> */}
              <input ref={imgRef} type="file" className="d-none" />
            </div>
            <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0 table-striped">
                <thead className="table-light">
                  <tr>
                    <th width="10">S No.</th>
                    <th>Packing Type</th>
                    <th>Rate PER(cbm OR sq/mt)</th>
                    <th>Minimum</th>
                    {/* <th>% Freight MU</th> */}
                  </tr>
                </thead>
                <tbody>
                  {listData &&
                    listData.data.packings.length &&
                    listData.data.packings.map((item, key) => (
                      <tr key={key}>
                        <td>{key + 1}</td>
                        <td>{item.packing_type.split("_").join(" ")}</td>
                        <td>{showLabel(item)}</td>
                        <td>{item.minimum ? item.minimum : "-"}</td>
                        {/* <td>{item.percentage_fright_mu ? item.percentage_fright_mu : '-'}</td> */}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
          <Loader isShow={loader} />
        </div>
      </div>
    </div>
  );
};
